import Vue from 'vue'

/** 全局打开操作助手（与 App 内 Host 单例 drawer 联动） */
export const leoOperatorAssistantBus = new Vue()

export function openLeoOperatorAssistant () {
  leoOperatorAssistantBus.$emit('open')
}

export function closeLeoOperatorAssistant () {
  leoOperatorAssistantBus.$emit('close')
}

/** 是否在当前路由显示操作助手 FAB */
export function routeShowsOperatorAssistant (route) {
  if (!route || !route.path) {
    return false
  }
  const name = String(route.name || '')
  const hidden = new Set([
    'login',
    'leoLogin',
    'leoPortal',
    'leoConsole',
    'leoStandaloneChat',
    'leoTrainingDecisionDeskMobile',
    'leoMembershipLogin',
    'leoMembershipRegister'
  ])
  if (hidden.has(name)) {
    return false
  }
  const p = String(route.path || '').toLowerCase()
  if (p === '/login') {
    return false
  }
  if (p.startsWith('/leo/') || p.startsWith('/leo-')) {
    return true
  }
  if (p.indexOf('ai-trustee') >= 0 || p.indexOf('portal-ops') >= 0) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/leoOperatorAssistant.js